import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkflowRuleActionEdit } from '../../workflow-rule-action-edit-implemention';
import { Workflow, WorkflowStep, WorkflowStepRule, WorkflowStepRuleAction } from 'src/app/modules/core/store/models/workflow.model';
import { NavigationRuleConfiguration } from './navigation-edit.model';
import { TranslateService } from '@ngx-translate/core';
import { WorkflowRuleDataField } from 'src/app/modules/communications/store/workflow/workflow.models';
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
    selector: 'topo-navigation-rule-edit',
    templateUrl: './navigation-edit.component.html',
    styleUrls: ['./navigation-edit.component.scss'],
    standalone: false
})
export class NavigationRuleEditComponent implements OnInit, OnDestroy, WorkflowRuleActionEdit {
  @Input() schema: WorkflowRuleDataField[];
  @Input() workflow: Workflow;
  @Input() step: WorkflowStep;
  @Input() rule: WorkflowStepRule;
  @Input() implementationUId: string;
  @Input() readOnly: boolean;
  @Input() action: WorkflowStepRuleAction;

  destroy$: Subject<void> = new Subject();

  workflowStepListItems: WorkflowStep[];
  selectedStepUId: string;
  selectedStatusColorCode: string;
  isActive: boolean;
  selectedStatusName: string;

  constructor(private translationService: TranslateService, private notify: SystemNotificationsService) {}

  load(): void {
    this.workflowStepListItems = [];

    const actions = this.step.actions.filter(a => !!a.destinationStepUId).sort((s1, s2) => s1.sortOrder - s2.sortOrder);

    actions.map(a => {
      this.workflowStepListItems.push(this.workflow?.workflowSteps.find(ws => ws.uId === a.destinationStepUId));
    });

    let settings = this.action?.configuration ? JSON.parse(this.action.configuration) as NavigationRuleConfiguration : null;
    if (settings && settings.targetStepUId) {
      const destStep = this.workflow?.workflowSteps.find(ws => ws.uId === settings.targetStepUId);
      this.selectedStepUId = destStep.uId;
      this.selectedStatusColorCode = destStep.statusHtmlColorCode;
      this.selectedStatusName = destStep?.statusName;
    }
  }

  private getDisplayText(): string {
    let stepName = "";
    let settings = this.action?.configuration ? JSON.parse(this.action.configuration) as NavigationRuleConfiguration : null;
    if (settings && settings.targetStepUId) {
      const destStep = this.workflow?.workflowSteps.find(ws => ws.uId === settings.targetStepUId);
      stepName = destStep?.statusName;
    }
    let desc = this.translationService.instant("MANAGEMENT.WORKFLOW.RULE-ACTION-DESC-NAVIGATION");
    desc += ` <b>${stepName}</b>`;
    return desc;
  }

  stepSelected(step: WorkflowStep): void {
    this.selectedStepUId = step.uId;
    this.selectedStatusColorCode = step.statusHtmlColorCode;
    this.selectedStatusName = step.statusName;
  }

  private validate(): boolean {
    if (this.selectedStepUId == null) {
      this.notify.error(this.translationService.instant('MANAGEMENT.WORKFLOW.RULE-ERROR-NO-STEP'));
      return false;
    }
    return true;
  }

  save(): boolean {
    if (!this.validate()) {
      return false;
    }

    let settings = {
      targetStepUId: this.selectedStepUId
    } as NavigationRuleConfiguration;

    this.action.configuration = JSON.stringify(settings);
    this.action.displayText = this.getDisplayText();
    return true;
  }

  getAction(): WorkflowStepRuleAction {
    const action = this.action;
    return action;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
